<template>
    <div>
       <h4 class="title">訂購紀錄</h4>
       <form class="form-inline">
         <div class="form-group">
           <datepicker v-model="choosemonth" language="zh" format="yyyy-MM"></datepicker>
         </div>
         <div class="form-group">
           <button type="button" class="btn btn-sm btn-success" :disabled="this.searchFlag" @click="getConsume()">查詢</button>
         </div>
       </form>
       <div class="member_content">
            <table class="table table-bordered">
                <thead>
                    <tr class="success">
                        <td>訂單明細</td>
                        <td>店家</td>
                        <td>售價</td>
                        <td>點數</td>
                        <td>付款方式</td>
                        <td>日期</td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    <tr class="even" role="row" v-for="(row, index) in this.consume" >
                      <td>
                        <button type="button"  class="btn btn-sm btn-primary" @click="getDetail(row.trans_main_id)">明細</button>
                      </td>
                      <td>{{row.companyname}}</td>
                      <td>{{row.t_count}}</td>
                      <td>{{row.t_point}}</td>
                      <td>
                        點數 {{row.sale_cash}}<br/>
                        現金 {{row.receive_cash}}
                      </td>
                      <td>{{row.c_date}}</td>
                      <td v-if="row.PositionCode=='999999999' && row.checkstate == 0 && row.ordercheck != 'user_cancel'">
                        <button type="button" class="btn btn-sm btn-danger" @click="cancel(row.trans_main_id)">取消</button>
                      </td>
                      <td v-else></td>
                    </tr>
                </tbody>
            </table>

      <modal title="Fade Modal" :show.sync="fadeModal" effect="fade" width="800">
        <div slot="modal-header" class="modal-header">
          <h4 class="modal-title"><b>購物明細</b></h4>
        </div>
        <div slot="modal-body" class="modal-body">
          <table class="table table-bordered">
                <thead>
                    <tr class="success">
                        <td>品名</td>
                        <td>售價</td>
                        <td>點數</td>
                        <td>數量</td>
                        <td>金額小計</td>
                        <td>購買日期</td>
                    </tr>
                </thead>
                <tbody>
                    <tr class="even" role="row" v-for="(row, index) in this.detail" >
                      <td>{{row.product[0].product_title}}</td>
                      <td>{{row.sale_price}}</td>
                      <td>{{row.sale_point}}</td>
                      <td>{{row.ordernumber}}</td>
                      <td>{{row.sale_price*row.ordernumber}}</td>
                      <td>{{row.c_date}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div slot="modal-footer" class="modal-footer">
          <button type="button" class="btn btn-default" @click='fadeModal = false'>關閉</button>
        </div>
      </modal>

      </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Datepicker from 'vuejs-datepicker'
import { modal } from 'vue-strap'

export default {
  props: ['show'],
  components: {
    Datepicker,
    modal
  },
  name: 'Order',
  data () {
    return {
      fadeModal: false,
      memberurl: this.$store.getters.getMemberAPI,
      userID: this.$store.getters.getUserID,
      token: '',
      consume: [],
      choosemonth: '',
      detail: '',
      apiurl: 'https://affiliate.i80.com.tw/',
      searchFlag: false
    }
  },
  mounted: function () {
    this.token = this.$store.getters.getToken
  },
  methods: {
    ...mapActions([
      'GET_NEWS'
    ]),
    getConsume () {
      let date = new Date(this.choosemonth)
      let queryDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2)
      this.searchFlag = true
      this.$http.get(this.memberurl + '/member_consume', {params: {token: this.token, month: queryDate}}).then(function (res) {
        this.searchFlag = false
        let data = res.body.data
        if (data.length > 0) {
          this.consume = data
        } else {
          window.alert('您該月份未有消費紀錄')
        }
      }, function () {
        console.log('failed')
      })
    },
    getDetail (id) {
      this.fadeModal = true
      this.$http.get(this.memberurl + '/member_consume_detail', {params: {token: this.token, id: id}}).then(function (res) {
        let data = res.body.data
        if (data.length > 0) {
          this.detail = data
        } else {
          window.alert('查詢失敗')
        }
      }, function () {
        console.log('failed')
      })
    },
    cancel (orderID) {
      this.$http.post(this.apiurl + 'api/cancelOrder', {
        orderid: orderID,
        id: this.userID,
        token: this.token
      }).then(function (res) {
        let data = res.body.data
        if (data.comid !== '') {
          window.alert('取消單據成功。')
          this.getConsume()
        } else {
          window.alert('取消單據失敗。')
        }
      }, function () {
        console.log('failed')
      })
    }
  },
  computed: {
    ...mapGetters([
      'getNews'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// Order.vue?587475ed